import * as React from "react";
import "./SingleColumnPage.scss";

interface ISingleColumnPageProps {
  header?: JSX.Element,
  body: JSX.Element
}

const SingleColumnPage: React.SFC<ISingleColumnPageProps> = ({header, body}) => {
  return (
    <div className="nzpost-js-tool-single-col-page">
      {header && (
        <div className="nzpost-js-tool-single-col-page-header">
          {header}
        </div>
      )}
      <div className="nzpost-js-tool-single-col-page-body">
        {body}
      </div>
    </div>
  );
};

export default SingleColumnPage;



// WEBPACK FOOTER //
// ./src/components/lib/Pages/SingleColumnPage/SingleColumnPage.tsx